'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["size", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import { useFillIds } from "../../hooks/useFillId";
import { TITLE } from "../style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '1em' : _ref$size,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useFillIds = useFillIds(TITLE, 13),
    _useFillIds2 = _slicedToArray(_useFillIds, 13),
    a = _useFillIds2[0],
    b = _useFillIds2[1],
    c = _useFillIds2[2],
    d = _useFillIds2[3],
    e = _useFillIds2[4],
    f = _useFillIds2[5],
    g = _useFillIds2[6],
    h = _useFillIds2[7],
    i = _useFillIds2[8],
    j = _useFillIds2[9],
    k = _useFillIds2[10],
    l = _useFillIds2[11],
    m = _useFillIds2[12];
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    height: size,
    ref: ref,
    style: _objectSpread({
      flex: 'none',
      lineHeight: 1
    }, style),
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("title", {
      children: TITLE
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: a.id,
        x1: "75.897%",
        x2: "26.312%",
        y1: "89.199%",
        y2: "12.194%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: ".06%",
          stopColor: "#0867DF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "45.39%",
          stopColor: "#0668E1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "85.91%",
          stopColor: "#0064E0"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: b.id,
        x1: "21.67%",
        x2: "97.068%",
        y1: "75.874%",
        y2: "23.985%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "13.23%",
          stopColor: "#0064DF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "99.88%",
          stopColor: "#0064E0"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: c.id,
        x1: "38.263%",
        x2: "60.895%",
        y1: "89.127%",
        y2: "16.131%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "1.47%",
          stopColor: "#0072EC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "68.81%",
          stopColor: "#0064DF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: d.id,
        x1: "47.032%",
        x2: "52.15%",
        y1: "90.19%",
        y2: "15.745%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "7.31%",
          stopColor: "#007CF6"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "99.43%",
          stopColor: "#0072EC"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: e.id,
        x1: "52.155%",
        x2: "47.591%",
        y1: "58.301%",
        y2: "37.004%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "7.31%",
          stopColor: "#007FF9"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#007CF6"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: f.id,
        x1: "37.689%",
        x2: "61.961%",
        y1: "12.502%",
        y2: "63.624%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "7.31%",
          stopColor: "#007FF9"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0082FB"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: g.id,
        x1: "34.808%",
        x2: "62.313%",
        y1: "68.859%",
        y2: "23.174%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "27.99%",
          stopColor: "#007FF8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "91.41%",
          stopColor: "#0082FB"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: h.id,
        x1: "43.762%",
        x2: "57.602%",
        y1: "6.235%",
        y2: "98.514%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#0082FB"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "99.95%",
          stopColor: "#0081FA"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: i.id,
        x1: "60.055%",
        x2: "39.88%",
        y1: "4.661%",
        y2: "69.077%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "6.19%",
          stopColor: "#0081FA"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0080F9"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: j.id,
        x1: "30.282%",
        x2: "61.081%",
        y1: "59.32%",
        y2: "33.244%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#027AF3"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0080F9"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: k.id,
        x1: "20.433%",
        x2: "82.112%",
        y1: "50.001%",
        y2: "50.001%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#0377EF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "99.94%",
          stopColor: "#0279F1"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: l.id,
        x1: "40.303%",
        x2: "72.394%",
        y1: "35.298%",
        y2: "57.811%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: ".19%",
          stopColor: "#0471E9"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0377EF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: m.id,
        x1: "32.254%",
        x2: "68.003%",
        y1: "19.719%",
        y2: "84.908%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "27.65%",
          stopColor: "#0867DF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0471E9"
        })]
      })]
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      fillRule: "nonzero",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.897 4h-.024l-.031 2.615h.022c1.715 0 3.046 1.357 5.94 6.246l.175.297.012.02 1.62-2.438-.012-.019a48.763 48.763 0 00-1.098-1.716 28.01 28.01 0 00-1.175-1.629C10.413 4.932 8.812 4 6.896 4z",
        fill: a.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.873 4C4.95 4.01 3.247 5.258 2.02 7.17a4.352 4.352 0 00-.01.017l2.254 1.231.011-.017c.718-1.083 1.61-1.774 2.568-1.785h.021L6.896 4h-.023z",
        fill: b.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M2.019 7.17l-.011.017C1.2 8.447.598 9.995.274 11.664l-.005.022 2.534.6.004-.022c.27-1.467.786-2.828 1.456-3.845l.011-.017L2.02 7.17z",
        fill: c.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M2.807 12.264l-2.533-.6-.005.022c-.177.918-.267 1.851-.269 2.786v.023l2.598.233v-.023a12.591 12.591 0 01.21-2.44z",
        fill: d.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M2.677 15.537a5.462 5.462 0 01-.079-.813v-.022L0 14.468v.024a8.89 8.89 0 00.146 1.652l2.535-.585a4.106 4.106 0 01-.004-.022z",
        fill: e.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.27 16.89c-.284-.31-.484-.756-.589-1.328l-.004-.021-2.535.585.004.021c.192 1.01.568 1.85 1.106 2.487l.014.017 2.018-1.745a2.106 2.106 0 01-.015-.016z",
        fill: f.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.78 9.654c-1.528 2.35-2.454 3.825-2.454 3.825-2.035 3.2-2.739 3.917-3.871 3.917a1.545 1.545 0 01-1.186-.508l-2.017 1.744.014.017C2.01 19.518 3.058 20 4.356 20c1.963 0 3.374-.928 5.884-5.33l1.766-3.13a41.283 41.283 0 00-1.227-1.886z",
        fill: "#0082FB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.502 5.946l-.016.016c-.4.43-.786.908-1.16 1.416.378.483.768 1.024 1.175 1.63.48-.743.928-1.345 1.367-1.807l.016-.016-1.382-1.24z",
        fill: g.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.918 5.713C19.853 4.633 18.583 4 17.225 4c-1.432 0-2.637.787-3.723 1.944l-.016.016 1.382 1.24.016-.017c.715-.747 1.408-1.12 2.176-1.12.826 0 1.6.39 2.27 1.075l.015.016 1.589-1.425-.016-.016z",
        fill: "#0082FB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.998 14.125c-.06-3.467-1.27-6.566-3.064-8.396l-.016-.016-1.588 1.424.015.016c1.35 1.392 2.277 3.98 2.361 6.971v.023h2.292v-.022z",
        fill: h.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.998 14.15v-.023h-2.292v.022c.004.14.006.282.006.424 0 .815-.121 1.474-.368 1.95l-.011.022 1.708 1.782.013-.02c.62-.96.946-2.293.946-3.91 0-.083 0-.165-.002-.247z",
        fill: i.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.344 16.52l-.011.02c-.214.402-.519.67-.917.787l.778 2.462a3.493 3.493 0 00.438-.182 3.558 3.558 0 001.366-1.218l.044-.065.012-.02-1.71-1.784z",
        fill: j.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.92 17.393c-.262 0-.492-.039-.718-.14l-.798 2.522c.449.153.927.222 1.46.222.492 0 .943-.073 1.352-.215l-.78-2.462c-.167.05-.341.075-.517.073z",
        fill: k.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.323 16.534l-.014-.017-1.836 1.914.016.017c.637.682 1.246 1.105 1.937 1.337l.797-2.52c-.291-.125-.573-.353-.9-.731z",
        fill: l.fill
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.309 16.515c-.55-.642-1.232-1.712-2.303-3.44l-1.396-2.336-.011-.02-1.62 2.438.012.02.989 1.668c.959 1.61 1.74 2.774 2.493 3.585l.016.016 1.834-1.914a2.353 2.353 0 01-.014-.017z",
        fill: m.fill
      })]
    })]
  }));
});
export default Icon;